import React from 'react';
import { UniverseModuleType } from 'src/domains/common/universes.type';
import { features } from './bestodds.features';
import { themeColors } from './bestodds.config';
import { BestOddsLogotype } from './bestodds.logotype';
import { BestOddsLogo } from 'src/layouts/LoginPage/logos/BestOddsLogo';
import BestOddsLoginImage from 'src/layouts/LoginPage/loginBgImages/BestOddsLoginImage.png';
import { BestOddsBrandIconWrapper, CompliancePopupLogo } from './bestodds.style';
import { LoginImageWrapperWithBackground } from 'src/layouts/LoginPage/LoginImage.style';

export const universeModule: UniverseModuleType = {
    themeColors,
    features,
    title: 'BestOdds Backoffice',
    urls: {
        website: 'https://bet.bestodds.com/',
        backoffice: 'https://backoffice.bet.bestodds.com/',
    },
    BrandIcon: () => <BestOddsBrandIconWrapper />,
    Logotype: () => <BestOddsLogotype />,
    LogotypeLoginPage: () => <BestOddsLogo />,
    compliancePopupLogo: () => <CompliancePopupLogo />,
    loginImageContainer: () => <LoginImageWrapperWithBackground imgSrc={BestOddsLoginImage} />,
};
